import { MaterialCommunityIcons } from "@expo/vector-icons";
import { IconProps } from "@ui-kitten/components";
import React from "react";
import { StyleSheet } from "react-native";

const MaterialCommunityIcon = ({ name, style }: IconProps) => {
  const { height, tintColor, ...iconStyle } = StyleSheet.flatten(style);
  return (
    <MaterialCommunityIcons
      color={tintColor}
      name={name}
      size={height}
      style={iconStyle}
    />
  );
};

const IconProvider = (name: PropertyKey) => ({
  toReactElement: (props) => MaterialCommunityIcon({ name, ...props }),
});

const MaterialCommunityIconsPack = {
  icons: new Proxy(
    {},
    {
      get: (target, name) => IconProvider(name),
    }
  ),
  name: "MaterialCommunityIcons",
};

export default MaterialCommunityIconsPack;
